module.exports = __webpack_public_path__ + "static/media/build_product.96e1abb5.svg";